import { render, staticRenderFns } from "./RightPanelContainerIcon.vue?vue&type=template&id=898142e2&scoped=true&"
import script from "./RightPanelContainerIcon.vue?vue&type=script&lang=js&"
export * from "./RightPanelContainerIcon.vue?vue&type=script&lang=js&"
import style0 from "./RightPanelContainerIcon.vue?vue&type=style&index=0&id=898142e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898142e2",
  null
  
)

export default component.exports